import $ from "jquery";

$(document).ready(function() {

    $(".accordion__answer").hide();

    $(".accordion__question").click(function () {
        $(".accordion__answer").slideUp("slow");
        $(".accordion__icon").removeClass("icon-minus");
        if ($(this).siblings(".accordion__answer-container").find(".accordion__answer")[0].style.display === 'block') {
            console.log('answe is block')
            $(this).find(".accordion__answer-container").slideUp("slow");
            $(this).find(".accordion__icon").removeClass("icon-minus");
        } else if ($(this).siblings(".accordion__answer-container").find(".accordion__answer")[0].style.display === 'none') {
            console.log('answe is none')
            $(this).siblings(".accordion__answer-container").find(".accordion__answer").slideDown("slow");
            $(this).find(".accordion__icon").addClass("icon-minus");
        }
    });
})